export default "__VITE_ASSET__Dqb2GGBY__"